/**
 * Which capture uploads of one picker dialog are orphans (spec 2026-09-27 §3.4): uploaded here
 * and not the capture the dialog ends up emitting. A capture the record already owns (it came
 * in on `existingLink`) is never ours to delete — the api releases it on save.
 */
export class CaptureSession {
  private uploaded = new Set<string>();

  track(uuid: string): void { this.uploaded.add(uuid); }

  forget(uuid: string): void { this.uploaded.delete(uuid); }

  /** Orphans once the dialog ends keeping `kept` (the emitted link's capture, or null on Cancel / Remove). */
  orphans(kept: string | null): string[] {
    return [...this.uploaded].filter(uuid => uuid !== kept);
  }

  /** On a new capture or Delete markup: the previous capture to delete now, only when this session uploaded it. */
  replaceable(previous: string | null): string | null {
    return previous && this.uploaded.has(previous) ? previous : null;
  }
}

export const CAPTURE_FAILED = "Couldn't capture the map. Try again.";
export const CAPTURE_UPLOAD_FAILED = "Couldn't upload the capture. Try again.";
